<template>
  <v-app :dark="$root.config.dark" id="app">
    <v-toolbar dense clipped-left dark app :color="$config.colors.primary" :class="['unselectable']">
      <v-toolbar-side-icon @click="nav = !nav" aria-label="toggle-sidebar">
        <v-icon>menu</v-icon>
      </v-toolbar-side-icon>
      <v-toolbar-title v-html="$config.appName" />
      <v-spacer />
      <v-btn small :href="$config.payPalDonateLink" rel="noreferrer" target="_blank" dark aria-label="donate" :color="$config.colors.accent" :title="$lang.donate">{{ $lang.donate }}</v-btn>
    </v-toolbar>
    <v-navigation-drawer app clipped v-model="nav" :class="['elevation-8']">
      <v-container :class="['text-xs-center', 'pb-3']">
        <router-link to="/" :class="['logo-avatar-wrapper', 'elevation-10']" :title="$config.appName">
          <v-avatar :color="$config.colors.primary" size="96">
            <v-icon size="48">{{ $config.appIcon }}</v-icon>
          </v-avatar>
        </router-link>
      </v-container>
      <navigation />
    </v-navigation-drawer>
    <v-content>
      <page-header />
      <router-view />
    </v-content>
    <v-footer inset app :class="['py-4', 'elevation-12']">
      <span :class="['caption', 'ml-4']">
        <template v-for="(link, index) in footerLinks">
        <a :class="[`${$config.colors.primary}--text`]" rel="noreferrer" :href="link.url" target="_blank" :key="index" v-html="link.label" :title="link.label" /><strong v-if="index < footerLinks.length - 1" :key="`${index}-divider`">&nbsp;&middot;&nbsp;</strong>
      </template>
      </span>
      <v-spacer />
      <span :class="['mr-4', 'caption']">&copy;{{ date.getFullYear() }}&nbsp;|&nbsp;{{ $root.config.version }}</span>
    </v-footer>
    <social-services />
    <vc-style>
    aside .v-list .v-list__tile--active .v-icon,
    aside .v-list .v-list__tile--active .v-list__tile__title
    {
      color: {{ $root.config.colors.hex }} !important;
    }
    </vc-style>
  </v-app>
</template>
<script>
import Navigation from './components/navigation'
import PageHeader from './components/page-header'
import footerLinks from './helpers/footer-links'

export default {
  name: 'App',
  components: {
    Navigation,
    PageHeader
  },
  data () {
    return {
      nav: null,
      footerLinks,
      date: new Date()
    }
  }
}
</script>
<style>
html
{
  cursor: default;
  scroll-behavior: smooth;
}

*
{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.unselectable
{
  user-select: none;
}

.clickable
{
  cursor: pointer;
}

.logo-avatar-wrapper
{
  display: inline-block;
  border-radius: 100%;
  text-decoration: none;
}

.body--theme--dark::-webkit-scrollbar,
.body--theme--dark::-webkit-scrollbar-track,
.body--theme--dark ::-webkit-scrollbar,
.body--theme--dark ::-webkit-scrollbar-track
{
  background-color: #424242;
}

.body--theme--dark::-webkit-scrollbar,
.body--theme--dark ::-webkit-scrollbar
{
  width: 15px;
}

code,
.body--theme--dark::-webkit-scrollbar-thumb,
.body--theme--dark ::-webkit-scrollbar-thumb
{
  background-color: #212121 !important;
}

code
{
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue